import { SVGProps } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
  shiny?: boolean;
}

export const CollectionArrow = ({
  title,
  titleId,
  shiny = true,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    aria-labelledby={titleId}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Arrow up down">
      <g id="Icon" filter={shiny ? 'url(#filter0_di_434_90541)' : undefined}>
        <path
          d="M11.8696 14.7273L7 14.7273L7 12.9091L15 6L23 12.9091L23 14.7273L18.1304 14.7273L18.1304 22L11.8696 22L11.8696 14.7273Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_di_434_90541"
        x="0"
        y="0"
        width="30"
        height="30"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="3.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.941176 0 0 0 0 0.807843 0 0 0 0 0.113725 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_434_90541"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_434_90541"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_434_90541"
        />
      </filter>
    </defs>
  </svg>
);
